<script>
import InboxCreateDialog from "@/components/profile/administrationManagement/inboxes/InboxCreateDialog.vue";
import InboxManagementTable from "@/components/profile/administrationManagement/inboxes/InboxManagementTable.vue";
import LargeTabHeader from "@/components/common/tabs/LargeTabHeader.vue";

export default {
  components: {LargeTabHeader, InboxCreateDialog, InboxManagementTable},
  methods: {
    onInboxCreated() {
      this?.$refs?.inboxManagementTable?.getInboxesList()
      && this.$refs.inboxManagementTable.getInboxesList()
      return this.showNotification('success',
        this.$t('page.myOrganizations.inbox.created.success')
      )
    },
  }
}
</script>

<template>
  <v-container fluid>
    <!--    HEADER-->
    <LargeTabHeader
      :title="$t('heading.inbox.administration')"
      :subtitle="$t('subheading.inbox.administration')"/>

    <v-divider></v-divider>
    <InboxCreateDialog
      v-if="$permissions.hasInput && $store.getters.selectedOrganization.IsAdmin"
      class="text-end ma-0 py-3"
      @created="onInboxCreated" />
    <InboxManagementTable
      v-if="$permissions.hasInput && $store.getters.selectedOrganization.IsAdmin"
      ref="inboxManagementTable" />
  </v-container>
</template>

<style scoped>

</style>
